var React = require('react');

function FacebookLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#a8abb6","d":"M243.196 0C108.891 0 0 108.891 0 243.196s108.891 243.196 243.196 243.196 243.196-108.891 243.196-243.196C486.392 108.861 377.501 0 243.196 0zm62.866 243.165l-39.854.03-.03 145.917h-54.689V243.196H175.01v-50.281l36.479-.03-.061-29.609c0-41.039 11.126-65.997 59.431-65.997h40.249v50.311h-25.171c-18.817 0-19.729 7.022-19.729 20.124l-.061 25.171h45.234l-5.319 50.28z"}));
}

FacebookLogo.defaultProps = {"width":"512","height":"512","viewBox":"0 0 486.392 486.392"};

module.exports = FacebookLogo;

FacebookLogo.default = FacebookLogo;
